const FarmReport = {

    // FIELDS
    "farm": "Farm",
    "room": "Room",
    "crop": "Crop",
    "from_date": "From Date",
    "to_date": "To Date",

    // BUTTON
    "generate": "Generate",

    // TOAST
    "success": "Generated Successfully",

    // TOOLTIP
    "preview": "Preview",

    // PAGE HEADER
    "farm_report": "Farm Report",

    // ERROR
    "error_farm": "Select Farm",
    "error_room": "Select Room",
    "error_crop": "Select Crop",
    "error_from_date": "Choose From Date",
    "error_to_date": "Choose To Date",

    // TABLE HEADER
    "table_farm": 'FARM',
    "table_room": 'ROOM',
    "table_crop": 'CROP',
    "table_from_date": "FROM DATE",
    "table_to_date": "TO DATE",
    "table_generated_d&t": "GENERATED D&T",

}

export default FarmReport;